import './styles.css';
import React from 'react';
import CompoundInterestSimulator from './CompoundInterestSimulator';

function App() {
  return (
    <div className="App">
      <CompoundInterestSimulator />
    </div>
  );
}

export default App;
